document.addEventListener('DOMContentLoaded', () => {
  const modal = document.querySelector('.installments-modal');
  const overlay = document.querySelector('.installments-modal-overlay');
  const openButtons = document.querySelectorAll('.js-installments-modal');
  const closeIcon = modal?.querySelector('.icon-close');

  if (!modal || !overlay || !openButtons.length || !closeIcon) return;

  /**
   *
   */
  const updateInstallments = () => {
    if (!modal.classList.contains('installments-modal--cart')) return;

    const totalPriceEl = document.querySelector('#total_price');
    if (!totalPriceEl) return;

    const priceText = totalPriceEl.textContent
      .replace(/\s*zł\s*/i, '')
      .replace(/\s/g, '')
      .replace(',', '.');
    const totalPrice = parseFloat(priceText);

    // eslint-disable-next-line no-restricted-globals
    if (isNaN(totalPrice)) return;

    document.querySelectorAll('strong.buy-in-installments__data-count').forEach((el) => {
      const count = parseInt(el.dataset.count, 10);
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(count) && count > 0) {
        const installment = (totalPrice / count).toFixed(2);
        // eslint-disable-next-line no-param-reassign
        el.textContent = `${installment}${window.CURRENCY_SYMBOL}`;
      }
    });

    const creditAgricoleButton = document.querySelector('.js-credit-agricole-calculator');
    if (creditAgricoleButton) {
      creditAgricoleButton.setAttribute('data-price', totalPrice.toFixed(2));
    }

    const santanderButton = document.querySelector('.js-santander-calculator');
    if (santanderButton) {
      santanderButton.setAttribute('data-price', totalPrice.toFixed(2));
    }
  };

  /**
   *
   */
  const openModal = () => {
    modal.classList.add('is-active');
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    updateInstallments();
  };

  /**
   *
   */
  const closeModal = () => {
    modal.classList.remove('is-active');
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  };

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.js-installments-modal');
    if (btn) {
      openModal();
    }
  });

  closeIcon.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeModal();
    }
  });

  const creditAgricoleButton = document.querySelector('.js-credit-agricole-calculator');

  if (creditAgricoleButton) {
    creditAgricoleButton.addEventListener('click', function () {
      const shopId = creditAgricoleButton.getAttribute('data-shop-id');
      const orderAmount = creditAgricoleButton.getAttribute('data-price');

      const url = `https://ewniosek.credit-agricole.pl/platforma-kredytowa/symulacja?shopId=${shopId}&orderAmount=${orderAmount}`;
      const isMobile = /Mobi|Android/i.test(navigator.userAgent);

      if (isMobile) {
        window.location.href = url;
      } else {
        window.open(url, '_blank');
      }
    });
  }

  const santanderButton = document.querySelector('.js-santander-calculator');

  if (santanderButton) {
    santanderButton.addEventListener('click', function () {
      const orderAmount = santanderButton.getAttribute('data-price');
      const storeNumber = santanderButton.getAttribute('data-store-number');
      const count = santanderButton.getAttribute('data-count');

      const url = `https://wniosek.eraty.pl/symulator/oblicz/numerSklepu/${storeNumber}/typProduktu/0/wartoscTowarow/${orderAmount}/liczbaRat/${count}`;
      const isMobile = /Mobi|Android/i.test(navigator.userAgent);

      if (isMobile) {
        window.location.href = url;
      } else {
        window.open(url, '_blank');
      }
    });
  }
});
